import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface CategoryBadgeProps {
    id: string | null
    name: string | null
    color: string | null
    className?: string
}

const CategoryBadge: FC<CategoryBadgeProps> = ({
    id,
    name,
    color,
    className
}): ReactNode => {
    if (!id || !name) {
        return (
            <span className={cn('inline-flex h-6 items-center text-xs text-muted-foreground', className)}>
                Sin categoría
            </span>
        )
    }

    return (
        <span
            className={cn(
                'inline-flex h-6 max-w-full items-center gap-1.5 rounded-full border bg-background px-2 text-xs font-medium text-foreground',
                className
            )}
        >
            <span
                className='size-2 shrink-0 rounded-full'
                style={{ backgroundColor: color ?? 'var(--muted-foreground)' }}
                aria-hidden='true'
            />
            <span className='truncate' data-mdlfy-cms={`categories:${id}:name`}>{name}</span>
        </span>
    )
}

export default CategoryBadge
